export default __webpack_public_path__ + "static/media/balls-bg.369ba785.png";